/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_OnInputs */

const en_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const ar_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#تشغيل`)
};

const bn_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const de_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const es_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const fr_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const pt_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const zh_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const tr_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const ru_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

const pl_svtag_on = /** @type {(inputs: Svtag_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#ON`)
};

/**
* | output |
* | --- |
* | "#ON" |
*
* @param {Svtag_OnInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_on = /** @type {((inputs?: Svtag_OnInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_OnInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_on(inputs)
	if (locale === "bn") return bn_svtag_on(inputs)
	if (locale === "de") return de_svtag_on(inputs)
	if (locale === "es") return es_svtag_on(inputs)
	if (locale === "fr") return fr_svtag_on(inputs)
	if (locale === "pt") return pt_svtag_on(inputs)
	if (locale === "zh") return zh_svtag_on(inputs)
	if (locale === "tr") return tr_svtag_on(inputs)
	if (locale === "ru") return ru_svtag_on(inputs)
	if (locale === "pl") return pl_svtag_on(inputs)
	return en_svtag_on(inputs)
});